import { siftConstants } from "../_constants";
import { canopyServices } from "../_services";
import fetchUtil from "../_services/fetchUtil";
import config from "config";

const loopLimit = 700;

const GENERIC_JOB_ERROR = "An error has occurred. If the problem persists, consider submitting a bug report to the SIFT team.";

const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

// Job poll `error` is either a message (string or string[]) or an object whose
// message lives on `error` or `msg`, sometimes nested one level further.
function collectJobErrorMessages(value, depth = 0) {
  if (depth > 4 || value == null || value === false || value === true) return [];
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed ? [trimmed] : [];
  }
  if (Array.isArray(value)) {
    return value.flatMap((item) => collectJobErrorMessages(item, depth + 1));
  }
  if (typeof value === "object") {
    const nested = collectJobErrorMessages(value.error, depth + 1);
    if (nested.length) return nested;
    return collectJobErrorMessages(value.msg, depth + 1);
  }
  return [];
}

export async function execute_sift_run(inputs) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...inputs }),
    // body: JSON.stringify({ ...inputs, job_type: type }),
  };
  return fetch(`${inputs.url}`, requestOptions);
}

export async function execute_quick_run(inputs) {
  let job_object = {
    job_type: "sift-single-run",
    sift_single_run: true,
    run_count: 1,
  };

  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ ...job_object }),
  };
  return fetchUtil(`${config.apiUrl}/dash/jobs/`, requestOptions);
}

export async function execute_job(inputs = undefined, type) {
  let job_inputs = type === "export-job" ? { export_type: inputs.export_type, job_type: type } : type === "weather-fetch" ? { job_type: type } : { ...inputs, job_type: type };
  console.log("quick job", job_inputs);
  const requestOptions = {
    method: "POST",
    //headers: { ...authHeader(), "Content-Type": "application/json" },
    // body: JSON.stringify({ ...job_inputs }),
    // body: job_inputs,
    body: JSON.stringify({ ...job_inputs }),
  };
  return fetchUtil(`${config.apiUrl}/dash/jobs/`, requestOptions);
  // return fetch(`${config.apiUrl}/dash/jobs/`, requestOptions);
}

export async function exe_job(inputs, type) {
  const requestOptions = {
    method: "POST",
    //headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify({
      ...inputs,
    }),
  };
  return fetchUtil(`${config.apiUrl}/dash/environShade/`, requestOptions);
}

export async function poll_job(job_inputs, type, dispatch) {
  let loopBool = true;
  let loopCount = 0;
  let sleep_amt = 1000;
  let results = { error: false, errors: [] };
  // polling loop
  while (loopBool) {
    // poll request to backend
    let job_poll;
    if (type === "env-shade") {
      job_poll = await canopyServices._getShadeResults(job_inputs.job_id);
    } else if (type === "sift-import") {
      job_poll = await get_hori_shade_job_status(job_inputs.job_id);
    } else {
      job_poll = await get_job_status(job_inputs.job_id);
    }

    if (type === "sift-init") {
      // updates ui state for run layout complete and modeling complete
      dispatch({ type: siftConstants.GENERATE_RESULTS_UPDATE, job_poll });
    }

    // console.log("job_poll", job_poll);
    if (job_poll.status == 100) {
      // JOB HAS COMPLETED
      loopBool = false;
      if (job_poll.count == 0 && type === "sift-init") {
        results.error = { msg: "No Results Returned" };
        return results;
      }
      //
      results.output = job_poll;
      if (type === "sift-init") {
        // console.log("jaldsjfasdkfjoaijewfasd", job_poll);
        results.output.results = await download_from_s3(job_poll["results"]);
      }

      if (type === "export-job") {
        await download_from_s3_to_pc(job_poll["url"], job_inputs.meta.file_name);
      }

      if (type === "weather-fetch") {
        results.output.job_output = await download_from_s3(job_poll["url"]);
      }

      if (type === "env-shade") {
        results.output.job_output = job_poll;
      }

      if (type === "sift-import") {
        results.output.results = await download_from_s3(job_poll["url"]);
      }

      results.meta = job_inputs;
      return results;
    } else if (job_poll.status == 50) {
      // CANCEL
      loopBool = false;
      results.error = { msg: "Cancelled" };
      return results;
    } else if (type !== "env-shade" && type !== "sift-import" && job_poll.status == 97) {
      // ERROR
      loopBool = false;

      const messages = collectJobErrorMessages(job_poll?.error);
      if (messages.length === 0) {
        messages.push(GENERIC_JOB_ERROR);
      }

      if (type === "weather-fetch" && job_poll.url == null) {
        messages.push(
          "An error has occurred while fetching weather data. Try requesting data from another weather source. If the problem persists, consider submitting a bug report to the SIFT team.",
        );
      }

      if (type === "export-job" && job_poll.url == null) {
        messages.push("An error has occurred while exporting your data. Check your inputs and try exporting again. If the problem persists, consider submitting a bug report to the SIFT team.");
      }

      if (type === "sift-single-run" && job_poll.url == null) {
        messages.push("An error has occurred with this quick run. If the problem persists, consider submitting a bug report to the SIFT team.");
      }

      results.errors = messages;
      results.err_details = messages;
      results.error = { msg: messages };
      results.is_error = true;
      return results;
    } else if (type === "sift-import" && job_poll.status === 97) {
      loopBool = false;
      let ret_error = ["There is no Horizon Shading Data available for this location."];
      results.error = true;
      results.errors = ret_error;
      results.err_details = ret_error;
      results.is_error = true;
      return results;
    } else if (loopCount > loopLimit && type == "sift-init") {
      loopBool = false;
      // TIMEOUT
      // // offer user to continue (reset loop count) or cancel
      // const { openModal: openModalWithState, renderModal: renderModalWithState } = useAwaitableModal({});
      // const time_out_resp = await openModalWithState()
      // console.log(time_out_resp)
      results.error = { msg: ["This SIFT run has timed-out. Check your inputs and try again. If the problem persists, consider submitting a bug report to the SIFT team."] };
      return results;
    } else {
      // wait a cool 1000ms then loop again
      await sleep(sleep_amt);
      sleep_amt += 100;
      loopCount += 1;
    }
  }
}

const cleanError = (errors) => {
  const jsonErrArr = JSON.parse(errors);
  const cleanedErrors = [];

  for (const item of jsonErrArr) {
    const cleanedString = JSON.parse(item);
    cleanedErrors.push(cleanedString);
  }

  // console.log("cleanedErrors", cleanedErrors);
  return cleanedErrors;
};

export async function download_from_s3(url) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "attachment" },
  };
  // return fetchUtil(url, requestOptions,false);
  return fetch(url, requestOptions).then((response) => {
    return response.json();
  });
}

export function download_from_s3_to_pc(url, file_name) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Disposition": "attachment" },
  };
  return fetch(url, requestOptions)
    .then((response) => response.blob())
    .then((blob) => {
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement("a");
      a.href = url;
      a.download = file_name;
      document.body.appendChild(a); // have to do this for firefox or it doesn't work
      a.click();
      a.remove();
    });

  // .then((res) => res.blob())
  // .then((blob) => {
  //   let file = window.URL.createObjectURL(blob);
  //   window.location.assign(file);
  // });
}

export function upload_to_s3(url, data) {
  const requestOptions = {
    method: "PUT",
    // headers: { "Content-Type": "application/json" },
    // headers: { 'Content-Type': type },
    // body: JSON.stringify(data),
    body: data,
  };
  // console.log(data);
  // return fetchUtil(url, requestOptions, false);
  return fetch(url, requestOptions);
}

async function get_job_status(job_id) {
  const requestOptions = {
    method: "GET",
    // headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetchUtil(`${config.apiUrl}/dash/jobs/?job_id=${job_id}`, requestOptions).then((response) => response);
}

async function get_hori_shade_job_status(job_id) {
  const requestOptions = {
    method: "GET",
    // headers: { ...authHeader(), "Content-Type": "application/json" },
  };
  return fetchUtil(`${config.apiUrl}/dash/import/?runId=${job_id}`, requestOptions).then((response) => response);
}
